var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { RowsComponent } from '../list/rows.component';
import { ItemModalService } from './item-modal.service';
var ItemModalRowsComponent = /** @class */ (function (_super) {
    __extends(ItemModalRowsComponent, _super);
    function ItemModalRowsComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        return _this;
    }
    ItemModalRowsComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.clickable = true;
        this.querySubscription = this.service.observable.subscribe(function (data) {
            _super.prototype.onSubscribe.call(_this, data.value);
        });
    };
    ItemModalRowsComponent.prototype.onEvent = function (e1, e2, rec) {
        if (e2 === 'rows') {
            this.service.getQuery({ limit: rec, page: 1 }, this.groupName);
            this.service.getList();
        }
    };
    ItemModalRowsComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.querySubscription.unsubscribe();
    };
    ItemModalRowsComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'item-modal-rows',
                    template: "<p class=\"-note\" id=\"{{ componentName }}\">\n  {{ (msg | async)['ListComponent.label.rows'] }}\n  <column-select [col]=\"{required: true, disabled: !clickable, params: {options: options}}\" [val]=\"pager.count_per_page\" [msg]=\"(msg | async)\" (changeVal)=\"onEvent('', 'rows', $event.val)\"></column-select>\n</p>\n"
                }] }
    ];
    /** @nocollapse */
    ItemModalRowsComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ItemModalService }
    ]; };
    return ItemModalRowsComponent;
}(RowsComponent));
export { ItemModalRowsComponent };
//# sourceMappingURL=item-modal-rows.component.js.map